import React, { useCallback, useEffect, useState } from 'react';
import { Grid, Typography, Box, TextField } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import AddIcon from '@mui/icons-material/Add';
import DefaultImage from './../../img/blank.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import firebase from "../../config/firebase/index";
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import { fontWeight } from '@mui/system';
import cityState from '../../pages/cityState.json';
import Autocomplete from '@mui/material/Autocomplete';
import ReactGA from 'react-ga';
import Dropdown from '../../component/DropdownAtom/index.jsx';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import ToggleButton from '../../component/ToggleButton/index.jsx';
var CryptoJS = require("crypto-js");

// const URL = "http://localhost:3000";
const URL = "https://saudebazi-18025.web.app";



const EditPost = (props) => {

    console.log("Props:: ", props);
    const { closePopUp, dealId } = props;
    let date = new Date(props.date);
    const classes = useStyles();
    const dealer = JSON.parse(localStorage.getItem("user"));

    const [productName, setProductName] = React.useState(props.productName);
    const dealerNumber = dealer[0].PhoneNo;
    const dealerName = CryptoJS.AES.decrypt(dealer[0].Name, encSecret.key).toString(CryptoJS.enc.Utf8);
    const dealerImage = dealer[0].img;

    const unit = ["kg", "क्विंटल", "टन"];
    const [show, setShow] = useState(false);
    const [qshow, setQshow] = useState(false);
    const [quantity, setQuantity] = useState("");
    const [place, setPlace] = useState("");
    const [max, setMax] = useState("");
    const [min, setMin] = useState("");
    const [message, setMessagePrice] = useState("");
    const [quantityUnit, setQuantityUnit] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [uploadProgress, setUploadProgress] = useState("");
    const [image, setImage] = useState(DefaultImage);
    const [fixedColor, setFixedColor] = useState('');
    const [products, setProducts] = useState([]);
    const [flag, setFlag] = useState(true);
    const [newWhatsapp, setNewWhatsapp] = useState("");
    const [isToggled, setIsToggled] = useState(false);
    const closePopUpHandler = () => {
        closePopUp(false)
    }

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const createdAt = () => {
        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }

    const dealEditOrDuplicatedCompleted = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const newDealCreationCompleted = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    // useEffect(() => {
    //     clickedDeal();
    // }, [])

    useEffect(() => {

        if (dealId) {
            firebase.database().ref(`Product/${dealId}`).on('value', deal => {
                const oldDeal = deal.val();
                console.log("OD :::: ", oldDeal);
                setQuantity(oldDeal.Quantity)
                setMessagePrice(oldDeal.Message)
                setQuantityUnit(oldDeal.QuantityUnit)
                setMax(CryptoJS.AES.decrypt(oldDeal.Max, encSecret.key).toString(CryptoJS.enc.Utf8))
                setMin(CryptoJS.AES.decrypt(oldDeal.Min, encSecret.key).toString(CryptoJS.enc.Utf8))
                setProductName(oldDeal.productName)
                setImage(oldDeal.image)
                setPlace(oldDeal.Place);
                activateQuantityUnit(oldDeal.QuantityUnit);
                // if (oldDeal.Place && oldDeal.productName && oldDeal.Message == "")
                //     setMessagePrice(`${oldDeal.Place} में ${oldDeal.productName} की इस डील को चेक करने के लिए लिंक पे क्लिक करे`)
            })
            // const link = "https://wa.me//send?text=http%3A%2F%2Flocalhost%3A3000%2FmarketView%2F" + dealId;
            // // const link = "https://wa.me/?text=https%3A%2F%2Fagrigravity-b70e4.web.app%2FmarketView%2F" + dealId;

            //     setWhatsapp(link);
            let today = createdAt();
            let currentDate = new Date(today);
            date.setDate(date.getDate() + 1);
            // if (currentDate < date) {
            //     updateDeal();
            // } else {
            //     createDeal();
            // }

        }
        firebase.database().ref("Commodity").once("value", snapshot => {

            const commodityData = snapshot.val();

            const tempCommodities = [];
            for (const key in commodityData) {

                const commodityObj = {
                    id: key,
                    ...commodityData[key],
                };
                tempCommodities.push(commodityObj);
            }
            console.log("Commodities ", tempCommodities);
            setProducts(tempCommodities)

        });

    }, []);

    // const ALLCommodities = useCallback(() => {

    // }, []);

    const activateQuantityUnit = (unit) => {
        if (unit == "kg")
            changeQuantity("Kg", 0);
        else if (unit == "क्विंटल")
            changeQuantity("Qutil", 1);
        else if (unit == "टन")
            changeQuantity("tan", 2);
    }

    // Upload file to firebase
    const fileUpload = (e) => {
        const file = e.target.files[0];
        const storageRef = firebase.storage();
        const uploadTask = storageRef.ref('All_Files/').child(file.name).put(file);

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(progress)
                console.log('Upload is ' + progress + '% done');
            },
            (error) => {
                // Handle unsuccessful uploads
                console.log("error:-", error)
            },
            () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setImage(downloadURL)
                });
            }
        )
    }


    const updateDeal = () => {
        try {
            const dealRef = firebase.database().ref('Product/' + dealId);
            dealRef.update({
                "Message": message,
                "Place": place,
                "Quantity": quantity,
                "QuantityUnit": quantityUnit,
                "Min": min,
                "Max": max,
                "image": image,

            });
        }
        catch (error) {
            console.log(error);
        }
        // finally{
        //     let today = createdAt();
        //     let currentDate = new Date(today);
        //     date.setDate(date.getDate() + 1);
        //     // console.log(date);
        //     if(currentDate < date)
        //     setWhatsapp(newWhatsapp);
        // }
    }



    const formatDate = (DATE) => {
        let d = DATE.split(" ");
        let dd = d[0].split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0] + " " + d[1];
        console.log("NDATE ::: ", newDATE);
        let nDate = new Date(newDATE);

        console.log("::: :", nDate);
        let dateArr = nDate.toString().split(" ");

        var result = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[3];
        return result;
        // return nDate.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true })
    }

    const formatProductName = (name) => {
        let Ename = name.split("(")[0].trim();
        return Ename.split(' ').join('-');
    }


    const createDeal = () => {
        if (place === "" && (min === "" || max === "") && quantity === "" && quantityUnit === "") {
            setShow(true);
        } else if (min < 0 || min > max) {
            setQshow(true);
        } else {
            const dealRef = firebase.database().ref().child('Product').push();
            const key = dealRef.key;
            const time = formatDate(createdAt());

            let shareLink = URL + "/marketView/" + key;
            // let link = `https://wa.me/?text=${place}%20में%20${productName}%20की%20इस%20डील%20को%20चेक%20करने%20के%20लिए%20लिंक%20पे%20क्लिक%20करे%3A%0D%20https%3A%2F%2Fsaudebazi-18025.web.app%2FmarketView%2F` + key;
            let textn = `*${productName}* के नवीनतम भाव` + "\n\n" + `*${place.trim()}* के सबसे अच्छे भाव पे बोली लगाएं` + "\n\n" + `सौदे की शर्त - ${message}` + "\n\n" + `*${dealerName}* का नवीनतम सौदा` + "\n\n" + `सौदेबाज़ी पर सर्वोत्तम मूल्य खोजें` + "\n\n" + `https://saudebazi-18025.web.app/marketView/${key}`

            let text = window.encodeURIComponent(textn);
            let link = "https://wa.me/?text=" + text;

            if (isToggled) {
                shareLink = URL + `/${formatProductName(productName)}-price-${place.trim()}-${time.trim()}` + key;

                textn = `*${productName}* के नवीनतम भाव` + "\n\n" + `*${place.trim()}* के सबसे अच्छे भाव पे बोली लगाएं` + "\n\n" + `सौदे की शर्त - ${message}` + "\n\n" + `*${dealerName}* का नवीनतम सौदा` + "\n\n" + `सौदेबाज़ी पर सर्वोत्तम मूल्य खोजें` + "\n\n" + `https://saudebazi-18025.web.app/${formatProductName(productName)}-price-${place.trim()}-${time.trim()}` + key;

                text = window.encodeURIComponent(textn);
                link = "https://wa.me/?text=" + text;

                // link = `https://wa.me/?text=${place}%20में%20${productName}%20की%20इस%20डील%20को%20चेक%20करने%20के%20लिए%20लिंक%20पे%20क्लिक%20करे%3A%0D%20https%3A%2F%2Fsaudebazi-18025.web.app%2F${formatProductName(productName)}-price-${place.trim()}-${time.trim()}` + key;

            }

            // const link = "https://wa.me/?text=http%3A%2F%2Flocalhost%3A3000%2FmarketView%2F" + key   ;
            setWhatsapp(link);
            setNewWhatsapp(link);
            const dealData = {
                "DealId": key,
                "DealerNumber": dealerNumber,
                "DealerName": CryptoJS.AES.encrypt(dealerName, encSecret.key).toString(),
                "DealerImage": dealerImage,
                "Message": message,
                "Quantity": quantity,
                "productName": productName,
                "QuantityUnit": quantityUnit,
                "Place": place,
                "isActive": true,
                "image": image,
                "Max": CryptoJS.AES.encrypt(max, encSecret.key).toString(),
                "Min": CryptoJS.AES.encrypt(min, encSecret.key).toString(),
                "createdAt": createdAt(),
                "shareLink": shareLink,
                "analytics": {
                    phone: 0,
                    whatsapp: 0,
                    views: 0
                },
                "isPublic": isToggled
            }
            dealRef.set(dealData).catch();

        }
    }

    const createNewDeal = () => {
        if (!dealId) {
            createDeal();
        } else {
            createDeal();
        }
    }

    const selProduct = (val) => {
        console.log("Selected Val :: ", val);
        setProductName(val);
        
    }

    const clickedDeal = () => {

        try {
            // firebase.database().ref("Product").orderByChild("DealId")
            //     .equalTo(dealId).on("value", snapshot => {

            //         const dealData = snapshot.val();
            //         const tempDeals = [];
            //         for (const key in dealData) {

            //             const dealObj = {
            //                 id: key,
            //                 ...dealData[key],
            //             };
            //             tempDeals.push(dealObj);
            //         }
            const link = "https://wa.me//send?text=http%3A%2F%2Flocalhost%3A3000%2FmarketView%2F" + dealId;
            // const link = "https://wa.me/?text=https%3A%2F%2Fagrigravity-b70e4.web.app%2FmarketView%2F" + dealId;

            let today = createdAt();
            let currentDate = new Date(today);
            date.setDate(date.getDate() + 1);
            // console.log(currentDate < date);
            // console.log(currentDate, date);
            if (currentDate < date) {
                updateDeal();
                setWhatsapp(link);
                dealEditOrDuplicatedCompleted('Duplicate Deal', 'Click', 'Share on WhatsApp');
            } else {
                createDeal();
                newDealCreationCompleted('New Deal', 'Click', 'Share on WhatsApp');
            }

            // })

        } catch (error) {
            console.log(error);
        }
    }

    const handleQuantity = (e) => {
        setQuantity(e.target.value);
    }

    const handleMaxPrice = (event) => {
        setMax(event.target.value);
    }

    const handleMinPrice = (event) => {
        setMin(event.target.value);
    }

    const handleMessage = (e) => {
        setMessagePrice(e.target.value);
    }

    const changeQuantity = (val, num) => {
        setFixedColor(val);
        setQuantityUnit(unit[num]);

    }

    const handlePlace = (event) => {
        setPlace(event.target.value);
    }


    return (
        <Grid p={2} className={classes.commonSectionBuild}>
            <NoFollowMeta />
            <Box className={classes.iconOverImage}>
                <img width="100%" height="200px" src={image} alt="" />
                <Box className={classes.editCenter}>
                    <label htmlFor="icon-button-file" className={classes.centerIconImage}>
                        <AddPhotoAlternateOutlinedIcon fontSize='large' />
                    </label>
                    <input hidden accept="/*" className={classes.input} id="icon-button-file" onChange={fileUpload} type="file" />
                </Box>
                <CloseIcon className={classes.topIconImage} style={{ fill: 'white' }} onClick={closePopUpHandler} />
                {uploadProgress > 0 && uploadProgress < 100 ?
                    <LinearProgress variant="determinateTextField" value={uploadProgress} />
                    : <></>
                }
            </Box>
            <Box className={classes.addDealContent}>
                <Typography style={{ display: show ? "block" : "none" }}>कृपया मान्य details भरें</Typography>
                <Box>
                    <Typography variant="h6" style={{ marginBottom: 10 }}>
                        वस्तु
                    </Typography>

                    {
                        (products && products.length > 0) ?
                            (<Dropdown products={products} selectedProduct={selProduct} productName={productName} />) :
                            (<TextfieldAtom value={productName} placeholder="chana" disabled />)
                    }
                </Box>

                <Box >

                    <Box className={classes.keematBox}>
                        <Box>
                            <Box className={`${classes.keematBox} ${classes.headerBrowser1}`} style={{ paddingTop: 0 }}>
                                <Typography variant="body1">स्थान</Typography>
                            </Box>

                            <TextfieldAtom placeholder="bikaner" value={place} onChange={(event) => handlePlace(event)} />
                        </Box>

                        <Box className={classes.contetnArrange}>
                            <Box mr={1}>
                                <Typography variant="body2">न्यूनतम</Typography>
                                <TextfieldAtom value={min}
                                    placeholder="Rs 5000"
                                    type="number"
                                    inputMode="numeric"
                                    onChange={(event) => handleMinPrice(event)} />
                            </Box>

                            <Box className={classes.toCenter}>
                                <Typography variant="h6">से</Typography>
                            </Box>

                            <Box ml={1}>
                                <Typography variant="body2">ज्यादा से ज्यादा </Typography>
                                <TextfieldAtom placeholder="Rs 5100"
                                    value={max}
                                    type="number"
                                    inputMode="numeric"
                                    onChange={(event) => handleMaxPrice(event)} />
                            </Box>
                        </Box>
                        <Typography style={{ display: qshow ? "block" : "none", color: 'red', textAlign: 'center' }}>कृपया मान्य मूल्य सीमा दर्ज करें</Typography>
                    </Box>


                </Box>

                <Box className={classes.headerBrowser2}>
                    {/* {/ <AddIcon className={classes.headerBrowser3} /> /} */}
                    {/* {/ <TextfieldAtom placeholder="ek aur sheher ki keemat jode" /> /} */}
                    {/* <ButtonAtom
                        startIcon={<AddIcon />}
                        name="एक और शहर की कीमत जोड़े "
                        cclass="templateButton1"
                        onClick={addNewArea}
                    /> */}
                </Box>

                <Typography variant="h6">लौट साइज </Typography>

                <Box style={{ display: "flex", justifyContent: "space-between" }}>

                    <Box width={"25%"} >
                        <TextfieldAtom placeholder="1"
                            type="number"
                            inputMode="numeric"
                            style={{ fontWeight: 600, }}
                            value={quantity}
                            onChange={handleQuantity} />
                    </Box>

                    <Box width={"25%"} ml={1}>
                        <ButtonAtom mb={3}
                            name="kg"
                            cclass={fixedColor == "kg" ? "ActiveButton" : "fixedButton"}
                            value={quantityUnit}
                            onClick={() => changeQuantity("kg", 0)}

                        />
                    </Box>

                    <Box width={"25%"} ml={1}>
                        <ButtonAtom mb={3}
                            name="क्विंटल"
                            cclass={fixedColor == "Qutil" ? "ActiveButton" : "fixedButton"}
                            value={quantityUnit}
                            onClick={() => changeQuantity("Qutil", 1)}

                        />
                    </Box>

                    <Box width={"25%"} ml={1}>
                        <ButtonAtom mb={3}
                            name="टन"
                            cclass={fixedColor == "tan" ? "ActiveButton" : "fixedButton"}
                            value={quantityUnit}
                            onClick={() => changeQuantity("tan", 2)}

                        />
                    </Box>
                </Box>
                <Box className={classes.headerBrowser2}>
                    <ToggleButton rounded={true} isToggled={!isToggled} onToggle={(val) => { setIsToggled(val); }} />
                    <Typography variant="h7" className={classes.textMiddleSet}>सार्वजनिक सौदा</Typography>
                </Box>

                <Box>
                    <Typography variant="h6">सन्देश</Typography>
                    <TextfieldAtom value={message} onChange={handleMessage} />
                </Box>
            </Box>
            <Box mt={4}>
                <a href={whatsapp} style={{ textDecoration: 'none' }}>
                    <ButtonAtom mb={3}
                        startIcon={<WhatsAppIcon />}
                        name="Share on whatsapp"
                        cclass="whatsUpBtn"
                        onClick={createNewDeal}
                    /></a>
            </Box>
        </Grid>
    )
};

const useStyles = makeStyles(() => ({
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        alignItems: 'center',
        boxSizing: 'border-box',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '40%',
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto',
        // padding: '0 15px',
        boxSizing: 'border-box',
    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',

    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }
    },
    commonNameCenter: {
        alignItems: 'center',
        marginLeft: '180px',
        marginRight: '60px',
        size: '20px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'
    },
    keematBox: {
        marginTop: 10,
        background: '#eee',
        padding: 15,
        boxSizing: 'border-box',
    },
    contetnArrange: {
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    centerIconImage: {
        position: 'absolute',
        left: '45%',
        top: '30%',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: '#fff'
    },
    iconOverImage: {
        position: 'relative',
        '& img': {
            marginTop: '-20px',
            '-webkit-filter': 'brightness(70%)'
        }
    },
    topIconImage: {
        position: 'absolute !important',
        left: '90%',
        bottom: '90%',
        transform: 'translate(-50%, -50%)',
        fill: 'white',
        cursor: 'pointer',
    },
    toCenter: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        textSize: '60px'
    },
    jyadaInputBlock: {
        marginLeft: '20px',
        marginRight: '20px',
        width: '20%',
    },
    editCenter: {
        position: 'absolute',
        top: '50%',
        right: '50%',
    },
    editIcon: {
        opacity: 0,
    },
    addDealContent: {
        paddingLeft: 20,
        paddingRight: 20,
    },
    bottomIconCancelImage: {
        cursor: 'pointer',
    },

}));
export default EditPost;